import { defaultTo, trim, toNumber } from "lodash";

export function fixNumber(v: string) {
  v = trim(v);
  v = v.replace(",", ".");
  return v;
}

export function parseFloatOrDefault(v: any, _defaultTo: number) {
  return defaultTo(toNumber(v), _defaultTo);
}
